import { render, staticRenderFns } from "./MessageEventDetail.vue?vue&type=template&id=5642b984&"
import script from "./MessageEventDetail.vue?vue&type=script&lang=js&"
export * from "./MessageEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5642b984')) {
      api.createRecord('5642b984', component.options)
    } else {
      api.reload('5642b984', component.options)
    }
    module.hot.accept("./MessageEventDetail.vue?vue&type=template&id=5642b984&", function () {
      api.rerender('5642b984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/MessageEventDetail.vue"
export default component.exports